<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>
      <v-card-text style="color: #4F4F4F">
        <div>
          <v-row class="pa-3" style="text-align: start">
            Congratulations! Your HawkSoft Data Sync configuration is complete.
            <br />PLEASE RESTART CMS to begin synchronizing your agency data with HawkSoft Data Sync.
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-row class="pa-3" justify="end">
          <v-btn color="#FF9E15" @click="returnToMarketplace()">Return to Marketplace</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';
import { mapGetters } from 'vuex';

export default {
  name: 'HawkSoftCloudSuccess',
  components: {
    ProductCardHeader
  },
  mixins: [productIdMappingMixin],
  computed: {
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('hawkSoftCloud'));
    }
  },
  methods: {
    returnToMarketplace () {
      this.$router.push('/marketplace');
    }
  }
};

</script>
